// Components
import EducationInfo from '../../Education';

// Context
import { useTranslationStore } from '../../../../context/Translation';

// Enums
import { LanguageResource } from '../../../../enums/Languages';

interface PropsInterface {
  closePopup: () => void;
  isLoading: boolean;
  setIsLoading: (arg0: boolean) => void;
}

const ProfilePopupCompleteLogin = (props: PropsInterface) => {
  const [t] = useTranslationStore();

  return (
    <div className="overflow-popup-wrapper">
      <div className="popup-wrapper">
        <p>{t(LanguageResource.Common + ':profile_login_missing_info')}</p>
        <p>{t(LanguageResource.Common + ':fill_in')}</p>
        <EducationInfo
          disableFieldOfStudy={true}
          disableCity={true}
          disableYearOfStudy={true}
          label={t(LanguageResource.Common + ':proceed')}
          isLoading={props.isLoading}
          setIsLoading={props.setIsLoading}
          proceedAction={() => props.closePopup()}
        />
      </div>
    </div>
  );
};

export default ProfilePopupCompleteLogin;
